export async function apiCallWrapper({
     commit,
     i18n = null,
     apiCall,
     successMessage = null,
     errorMessage = null,
 }) {
    try {
        commit("errors", null);
        commit("alerts", null);

        const response = await apiCall();

        if (successMessage) {
            commit("alerts", i18n ? i18n.t(successMessage) : successMessage);
        }

        return response;
    } catch (error) {
        const errorData = error?.response?.data;

        if (typeof errorData === 'object' && errorData !== null) {
            for (const key in errorData) {
                if (Array.isArray(errorData[key]) && errorData[key].length > 0) {
                    commit("errors", errorData[key][0]);
                    break;
                }
            }
        } else {
            const message = i18n && errorMessage
                ? i18n.t(errorMessage)
                : errorData || "Unknown error";
            commit("errors", message);
        }

        throw error;
    }
}
